export const cacheInstance = new Map<string, unknown>();

export const clearAllCache = (): void => {
  if (cacheInstance.size > 0) {
    cacheInstance.clear();
  }
};